import { Action } from '@ngrx/store';

export enum ELandlineMissionActions {
  SaveLandlineMission = '[LANDLINE_MISSION] Save landline mission',
  UpdateLandlineMission = '[LANDLINE_MISSION] Update landline mission',
  SaveLandlineMissionSuccess = '[LANDLINE_MISSION] Save landline mission success',
  SaveLandlineMissionFailure = '[LANDLINE_MISSION] Save landline mission failure'
}

export class UpdateLandlineMission implements Action {
  public readonly type = ELandlineMissionActions.UpdateLandlineMission;
  constructor(public payload: any, public procedureCode: string) {}
}

export class SaveLandlineMission implements Action {
  public readonly type = ELandlineMissionActions.SaveLandlineMission;
  constructor(public payload: any, public procedureCode: string) {}
}

export class SaveLandlineMissionSuccess implements Action {
  public readonly type = ELandlineMissionActions.SaveLandlineMissionSuccess;
  constructor(public payload: any) {}
}

export class SaveLandlineMissionFailure implements Action {
  public readonly type = ELandlineMissionActions.SaveLandlineMissionFailure;
}

export type LandlineMissionActions =
    SaveLandlineMission |
    UpdateLandlineMission |
    SaveLandlineMissionSuccess |
    SaveLandlineMissionFailure;
